import { render, staticRenderFns } from "./UserDetailPaymentsTab.vue?vue&type=template&id=762d4667&scoped=true&lang=pug&"
import script from "./UserDetailPaymentsTab.vue?vue&type=script&lang=js&"
export * from "./UserDetailPaymentsTab.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailPaymentsTab.vue?vue&type=style&index=0&id=762d4667&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762d4667",
  null
  
)

export default component.exports